var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google logo",
    clipPath: "url(#clip0_360_35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9999 9.19947C17.9999 8.4616 17.9386 7.92314 17.806 7.36475H9.18359V10.6952H14.2448C14.1428 11.5228 13.5918 12.7693 12.3672 13.6068L12.3501 13.7183L15.0763 15.7822L15.2652 15.8006C16.9999 14.235 17.9999 11.9316 17.9999 9.19947Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.18457 17.9743C11.6641 17.9743 13.7457 17.1765 15.2662 15.8005L12.3682 13.6067C11.5927 14.1352 10.5519 14.5042 9.18457 14.5042C6.75602 14.5042 4.69481 12.9387 3.96005 10.7749L3.85235 10.7838L1.01754 12.9277L0.980469 13.0284C2.49066 15.96 5.59271 17.9743 9.18457 17.9743Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.95914 10.7748C3.76527 10.2164 3.65307 9.61808 3.65307 8.99988C3.65307 8.38161 3.76527 7.78335 3.94894 7.22496L3.94381 7.10604L1.07348 4.92773L0.979568 4.97139C0.357147 6.18792 0 7.55403 0 8.99988C0 10.4457 0.357147 11.8118 0.979568 13.0283L3.95914 10.7748Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.18457 3.49591C10.909 3.49591 12.0723 4.22382 12.7356 4.83212L15.3274 2.35919C13.7356 0.91334 11.6641 0.0258789 9.18457 0.0258789C5.59271 0.0258789 2.49066 2.04009 0.980469 4.97167L3.94984 7.22524C4.69481 5.06145 6.75602 3.49591 9.18457 3.49591Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_360_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.cc514e46962d1d13ee131ca80224d16b.svg";
export { ForwardRef as ReactComponent };